import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import React from 'react'

interface iInfo {
  children: React.ReactNode
}

const Info = ({ children }: iInfo) =>
  <Box style={{ padding: '20px 20px', textAlign: 'center', width: '100%' }}>
    <Typography component="p"
                style={{ fontSize: '2rem', fontWeight: 700, lineHeight: 1.75, color: 'rgba(0, 0, 0, 0.30)' }}
    >
      {children}
    </Typography>
  </Box>

export default Info
